<template>
  <div class="wrap">
    <CourseList course_id="2" />
  </div>
</template>

<script>
import CourseList from "@/components/CourseList";
export default {
  name: "Home",
  components: {
    CourseList
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
